import { createAction } from 'Helpers';
import financialTypes from './types';

const financialActions = {
	balanceRequest: createAction(financialTypes.BALANCE.REQUEST),
	balanceSuccess: createAction(financialTypes.BALANCE.SUCCESS),
	balanceFailure: createAction(financialTypes.BALANCE.FAILURE),

	balanceDetailsRequest: createAction(financialTypes.BALANCE_DETAILS.REQUEST),
	balanceDetailsSuccess: createAction(financialTypes.BALANCE_DETAILS.SUCCESS),
	balanceDetailsFailure: createAction(financialTypes.BALANCE_DETAILS.FAILURE),

	verifyPaymentRequest: createAction(financialTypes.VERIFY_PAYMENT.REQUEST),
	verifyPaymentSuccess: createAction(financialTypes.VERIFY_PAYMENT.SUCCESS),
	verifyPaymentFailure: createAction(financialTypes.VERIFY_PAYMENT.FAILURE),

	requestPaymentRequest: createAction(financialTypes.PAYMENT_REQUEST.REQUEST),
	requestPaymentSuccess: createAction(financialTypes.PAYMENT_REQUEST.SUCCESS),
	requestPaymentFailure: createAction(financialTypes.PAYMENT_REQUEST.FAILURE),

	paymentHistoryListRequest: createAction(
		financialTypes.PAYMENT_HISTORY_LIST.REQUEST
	),
	paymentHistoryListSuccess: createAction(
		financialTypes.PAYMENT_HISTORY_LIST.SUCCESS
	),
	paymentHistoryListFailure: createAction(
		financialTypes.PAYMENT_HISTORY_LIST.FAILURE
	),

	paymentRequestDetailsRequest: createAction(
		financialTypes.PAYMENT_REQUEST_DETAILS.REQUEST
	),
	paymentRequestDetailsSuccess: createAction(
		financialTypes.PAYMENT_REQUEST_DETAILS.SUCCESS
	),
	paymentRequestDetailsFailure: createAction(
		financialTypes.PAYMENT_REQUEST_DETAILS.FAILURE
	),

	transactionsRequest: createAction(financialTypes.TRANSACTIONS.REQUEST),
	transactionsSuccess: createAction(financialTypes.TRANSACTIONS.SUCCESS),
	transactionsFailure: createAction(financialTypes.TRANSACTIONS.FAILURE),
};

export default financialActions;
